<template>
  <div class="select-item-warp">
    <div class="scroll-warp">
      <ul >
        <li v-for="item in list">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import IScroll from '@/better-scroll'
  const scrollOptions = {
    wheel: {
      selectedIndex: 0,
      /** 默认值就是下面配置的两个，为了展示二者的作用，这里再配置一下 */
      // wheelWrapperClass: 'wheel-scroll',
      // wheelItemClass: 'wheel-item'
    },
    probeType: 3
  }
  export default {
    props: {
      list: Array,
      column: {
        type: Number,
        default: 0
      },
      show: {
        type: Boolean,
        default: false
      },
    },
    computed:{
      currentShow: function(){
        return this.show
      }
    },
    watch:{
      show(val){
        // if(this.scroll){
        //   return
        // }
        // this._index =0
        // let _warp = this.$el.querySelector(".scroll-warp")
        // let defaultHeight = this.$el.querySelector(".scroll-warp").offsetHeight
        // this.scroll = new IScroll(_warp, scrollOptions )
        // let _this = this
        // this.scroll.on('scrollEnd', function(){
        //   let _y = this.y
        //   let index = parseInt(Math.abs(_y) / defaultHeight)
        //   if(_this._index !== index){
        //     _this._index = index
        //     _this.$emit("on-change" , index , _this.column)
        //   }
        // });
      },
      list(val){
        if(!this.scroll){
          this._index =0
          let _warp = this.$el.querySelector(".scroll-warp")
          let defaultHeight = this.$el.querySelector(".scroll-warp").offsetHeight
          this.scroll = new IScroll(_warp, scrollOptions )
          let _this = this
          this.scroll.on('scrollEnd', function(){
            let _y = this.y
            let index = parseInt(Math.abs(_y) / defaultHeight)
            if(_this._index !== index){
              _this._index = index
              _this.$emit("on-change", index)
            }
          });
        }
        this.$nextTick(function () {
          let _scroll = this.scroll
          let _column = this.column
          setTimeout(function(){
            _scroll.refresh()
            if(_column>0){
              _scroll.scrollTo(0, 0)
            }
          },100)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// item.vue?f1f3cf04